import React, { memo } from 'react';
import { EMBARGO_MODES } from '../constants';
import { EmbargoBanner } from './EmbargoBanner';
import type { EmbargoMode, EmbargoViolation } from '../types';

type EmbargoShipmentErrorsProps = {
  violations: EmbargoViolation[];
  warnings?: EmbargoViolation[];
  mode?: EmbargoMode;
  compact?: boolean;
};

const EmbargoShipmentErrorsComponent = ({
  violations,
  warnings = [],
  mode = EMBARGO_MODES.CREATE,
  compact = true,
}: EmbargoShipmentErrorsProps) => {
  const items = [...violations, ...warnings];
  if (!items.length) {
    return null;
  }
  return (
    <>
      {items.map((violation) => (
        <EmbargoBanner
          key={`${violation.shipmentRowId}-${violation.ruleId}-${violation.validationType}`}
          mode={mode}
          violation={violation}
          compact={compact}
        />
      ))}
    </>
  );
};

export const EmbargoShipmentErrors = memo(EmbargoShipmentErrorsComponent);
